module.exports = __webpack_public_path__ + "static/paymentFailed-d1f1fa799f1e80dadadc47d46279378f.png";